import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import { fieldName } from '@wolfdanepug/common-react'
import { noop } from 'lodash'
import { useState } from 'react'

export default function RadioControls({
	name,
	value: defaultValue = '',
	options = [],
	sx = {},
	row = true,
	onChange = noop
}: any) {
	const [value, setValue] = useState(defaultValue)

	const handleChange = (e: any) => {
		setValue(e.target.value)
		onChange(e)
	}

	return (
		<RadioGroup value={value} onChange={handleChange} row={row} sx={sx}>
			{options?.map((option: any, i: number) => (
				<Box
					key={i}
					sx={
						{
							// display: 'flex',
							// flexDirection: 'column',
							// justifyContent: 'flex-end',
							// alignItems: 'center'
						}
					}
				>
					{option.image && <img height={100} src={option.image} alt={option.label} />}
					<FormControlLabel
						key={i}
						name={fieldName.apply(null, name)}
						value={option.value}
						control={<Radio />}
						label={option.label}
					/>
				</Box>
			))}
		</RadioGroup>
	)
}
